import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';

const usePageTransition = () => {
  const [transitioning, setTransitioning] = useState(false);
  const [pendingPath, setPendingPath] = useState(null);
  const overlayRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!transitioning || !overlayRef.current) return;

    gsap.fromTo(
      overlayRef.current,
      { clipPath: "inset(0% 0% 100% 0%)" },
      {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.7,
        ease: "power4.inOut",
        onComplete: () => {
          navigate(pendingPath);
          setTimeout(() => setTransitioning(false), 0);
        },
      }
    );
  }, [transitioning, navigate, pendingPath]);

  useEffect(() => {
    if (transitioning || !overlayRef.current) return;

    // Slide up to reveal
    gsap.fromTo(
      overlayRef.current,
      { clipPath: "inset(0% 0% 0% 0%)" },
      {
        clipPath: "inset(100% 0% 0% 0%)",
        duration: 0.7,
        ease: "power4.inOut",
      }
    );
  }, [transitioning]);

  const handleNavigation = (path) => {
    setPendingPath(path);
    setTransitioning(true);
  };

  return { transitioning, handleNavigation, overlayRef };
};

export default usePageTransition;
